import ModalGiftConfirm from './ModalGiftConfirm'

export default ModalGiftConfirm
// eslint-disable-next-line import/export
export * from './ModalGiftConfirm'
